import { type JSX } from 'react';
import { Avatar } from '@doxyme/ui/components/foundations';
import { Icon } from '@doxyme/icons';

export const GetUserAvatarForNotification = (
  avatarSrc?: string,
): JSX.Element => {
  return Boolean(avatarSrc) ? (
    <Avatar src={avatarSrc} size='sm' />
  ) : (
    <Icon.User width={24} height={24} />
  );
};
